import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-onlinelook-2022-tab1',
  templateUrl: './tab1.component.html',
  styleUrls: ['./tab1.component.styl']
})
export class OnlinelookTab1Component implements OnInit {

  constructor(
    private http: HttpClient,
  ) { }

  ngOnInit() {

  }

}
